var $ = require('jquery');
var _ = require('lodash');

var resize_flash_object = function($obj) {
    var h_org = $obj.attr('height'),
        w_org = $obj.attr('width');
    if (!h_org || !w_org) {
        return;
    }
    var $par = $obj.parent();
    var w = Math.min($par.width(), w_org);
    var h = Math.min(Math.ceil(h_org/w_org*w), h_org);
    $obj.css('height', h);
    $obj.find('embed').css('height', h);
};

var resize_iframe = function($iframe) {
    var h_org = $iframe.attr('height'),
        w_org = $iframe.attr('width');
    var obj = $iframe.get(0);
    if (!h_org || !w_org) {
        return;
    }
    var w = Math.ceil(obj.contentWindow.document.body.scrollWidth);
    var h = Math.min(Math.ceil(h_org/w_org*w), h_org);
    $iframe.css('height', h);
};

var resize_ads = function() {
    $('.banner object').each(function(i, el){
        resize_flash_object($(el));
    });

    /*
     // Commented out for now, uncomment when first iframe appears
    $('.banner iframe').each(function(i, el){
        resize_iframe($(el));
    });
     */
};

var hide_tracking_pixels = function() {
    $('.banner img').each(function(i, el) {
        if (1 < el.naturalWidth && 1 < el.naturalHeight) {
            el.style.display = 'block';
        }
    });
};

$(function () {
    hide_tracking_pixels();
    $(window).on('resize orientationchange', _.throttle(resize_ads, 500));
    resize_ads();
});



//////////////////
// WEBPACK FOOTER
// ./common/js/bannerfix.js
// module id = 7
// module chunks = 0